import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { UserManagement } from '../components/UserManagement';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';

export const UserManagementPage: React.FC = () => {
  const { user } = useAuth();

  if (!user || !['CEO', 'GROUP_MANAGER'].includes(user.role)) {
    return (
      <DashboardLayout>
        <div className="flex flex-col items-center justify-center py-20">
          <ShieldAlert className="w-16 h-16 text-red-400 mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-gray-600">Only CEO and Group Manager roles can manage users.</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* User Management */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <UserManagement />
        </motion.div>
      </div>
    </DashboardLayout>
  );
};
